import "./PaginationMenu.css";
import Pagination from "react-bootstrap/Pagination";

export default function PaginationMenu(props) {
  // pagination menu with page numbers + back/next page buttons + ellipsis
  // pagination has: currPageNr, totalNrOfPages

  const currPage = props.pageNr;
  const isFirstPage = currPage === 1;
  const isLastPage = currPage === props.totalNrOfPages;

  const centerItems = (
    <>
      <Pagination.Item
        active={currPage === 1}
        onClick={() => props.handleChangePageNr(1)}
      >
        {1}
      </Pagination.Item>
      {currPage > 3 && <Pagination.Ellipsis onClick={() => props.handleChangePageNr(currPage - 3)} />}
  <>
    {Array.from({ length: 3 }, (_, idx) => (
      (currPage - 1 + idx > 1) && (currPage - 1 + idx < props.totalNrOfPages) && <Pagination.Item
        key={idx}
        active={idx===1}
        onClick={() => props.handleChangePageNr(currPage - 1 + idx)}
      >
        {currPage - 1 + idx}
      </Pagination.Item>
    ))}
  </>
      {currPage < props.totalNrOfPages - 2 && <Pagination.Ellipsis onClick={() => props.handleChangePageNr(currPage + 3)}/>}
      <Pagination.Item
        active={currPage === props.totalNrOfPages}
        onClick={() => props.handleChangePageNr(props.totalNrOfPages)}
      >
        {props.totalNrOfPages}
      </Pagination.Item>
    </>
  );

  return (
    <Pagination>
      <Pagination.Prev
        onClick={() => props.handleChangePageNr(currPage - 1)}
        disabled={isFirstPage}
      />
      {/* if up to 6 pages -> dont use ellipsis */}
      {props.totalNrOfPages < 7
        ? Array.from({ length: props?.totalNrOfPages }, (_, idx) => (
            <Pagination.Item
              active={currPage === idx + 1}
              key={idx}
              onClick={() => props.handleChangePageNr(idx + 1)}
            >
              {idx + 1}
            </Pagination.Item>
          ))
        : centerItems}
      <Pagination.Next
        onClick={() => props.handleChangePageNr(currPage + 1)}
        disabled={isLastPage}
      />
    </Pagination>
  );
}
